import { Navigate } from "react-router-dom";
import { useManagerLmsAccess } from "@/context/managerLmsAccessContext";
import LmsManagerCourseOverview from "@/routes/lms/lmsManagerCourseOverview";
import LmsMarketingCourseOverview from "@/routes/lms/lmsMarketingCourseOverview";

export default function LmsManagerCourseRoute() {
  const { mode } = useManagerLmsAccess();

  if (mode === "marketing") {
    return <LmsMarketingCourseOverview />;
  }

  if (mode === "full") {
    return <LmsManagerCourseOverview />;
  }

  return <Navigate to="/" replace />;
}
